<button class="btn btn--more" tabindex="0" title="Sluit" modal-close-btn>
    <span>Sluit</span>
    <svg class="svg-icon svg-icon--xs"><use href="assets/icons-ui.svg#cross-closed"></use></svg>
</button>
<h2 modal-title>Afwijkende bestuurder verwijderen</h2>
<div modal-content #cancelDriverContainer>
    <p>Weet u zeker dat u de voorgenomen verandering wilt verwijderen?</p>
    <div class="btn-group btn-group--spread">
        <button class="btn btn--link" (click)="close()">Annuleren</button>
        <button class="btn btn--primary" type="submit" (click)="submit()">Verwijderen</button>
    </div>
</div>
